import { TForeignTradeByProductsState } from './types';

export function getProductAggregated(state: TForeignTradeByProductsState) {
  return state.productAggregated;
}
